(() => {
  let activeDialog;
  let opener;
  const close = () => activeDialog?.close();
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-balance-quick-view]');
    if (button) {
      const template = button.parentElement.querySelector('[data-balance-quick-view-content]');
      if (!template || activeDialog) return;
      opener = button;
      activeDialog = template.content.firstElementChild.cloneNode(true);
      document.body.append(activeDialog);
      activeDialog.addEventListener('close', () => {
        activeDialog.remove();
        activeDialog = null;
        document.documentElement.classList.remove('balance-quick-view-open');
        opener?.focus();
      }, {once:true});
      activeDialog.querySelector('[data-balance-quick-view-close]').addEventListener('click', close);
      activeDialog.addEventListener('click', (click) => {
        if (click.target !== activeDialog) return;
        const bounds = activeDialog.getBoundingClientRect();
        if (click.clientX < bounds.left || click.clientX > bounds.right || click.clientY < bounds.top || click.clientY > bounds.bottom) close();
      });
      activeDialog.showModal();
      document.documentElement.classList.add('balance-quick-view-open');
      activeDialog.querySelector('[data-balance-quick-view-close]').focus();
    }
  });
})();
